import { getPathsFromConditions } from 'lib/utilities/form/utilities'
import React, { useEffect, useState } from 'react'
import SegmentedControls from './SegmentedControls'
import ConditionalLogic from './right/ConditionalLogic'

const OPTIONS = {
  ALWAYS: 'always',
  CONDITIONALLY: 'conditionally',
  NEVER: 'never',
}

const ConditionalControls = ({ initialValue, onUpdate, options = OPTIONS }) => {
  const [optionsControl, setOptionsControl] = useState([])
  const [selectedOption, setSelectedOption] = useState(OPTIONS.ALWAYS)
  const [conditionLogic, setConditionLogic] = useState('{}')
  const [linkedPaths, setLinkedPaths] = useState([])

  useEffect(() => {
    setOptionsControl(Object.values(options))
  }, [options])

  useEffect(() => {
    switch (initialValue) {
      case true:
      case undefined:
        setSelectedOption(OPTIONS.ALWAYS)
        break
      case false:
        setSelectedOption(OPTIONS.NEVER)
        break
      default:
        setSelectedOption(OPTIONS.CONDITIONALLY)
        setConditionLogic(JSON.stringify(initialValue, null, 4))
        setLinkedPaths(getPathsFromConditions(initialValue))
        break
    }
  }, [initialValue])

  const handleOptionSelect = (option) => {
    if (option === selectedOption) return
    setSelectedOption(option)
    switch (option) {
      case OPTIONS.CONDITIONALLY:
        onUpdate({})
        break
      case OPTIONS.NEVER:
        onUpdate(false)
        break
      default:
        onUpdate(true)
        break
    }
  }

  return (
    <div className='dome-d-flex dome-flex-column dome-gap12'>
      <SegmentedControls options={optionsControl} selectedOption={selectedOption} onOptionSelect={handleOptionSelect} />
      {selectedOption === OPTIONS.CONDITIONALLY && (
        <ConditionalLogic
          value={conditionLogic || '{}'}
          linkedPaths={linkedPaths}
          onSave={onUpdate}
          onChange={(e) => setConditionLogic(e.target.value)}
        />
      )}
    </div>
  )
}

export default ConditionalControls
